import { useEffect } from "react";
import { useCookieConsent } from "../contexts/CookieConsentContext";

const GA_MEASUREMENT_ID = "G-E1MDF7CX09";

const deleteCookie = (name) => {
  const hostnameParts = window.location.hostname.split(".");
  const domains = [
    window.location.hostname,
    `.${window.location.hostname}`,
    ...(hostnameParts.length > 2 ? [`.${hostnameParts.slice(-2).join(".")}`] : []),
  ];

  domains.forEach((domain) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}; SameSite=Lax`;
  });

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
};

const AnalyticsConsentBridge = () => {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (typeof window === "undefined" || hasConsent === null) {
      return;
    }

    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: hasConsent ? "granted" : "denied",
      });
    }

    window[`ga-disable-${GA_MEASUREMENT_ID}`] = !hasConsent;

    if (!hasConsent) {
      deleteCookie("_ga");
      deleteCookie("_ga_E1MDF7CX09");

      if (window.clarity) {
        try {
          window.clarity("consent", false);
        } catch {
          // Best-effort revoke hook.
        }
      }
    } else if (window.clarity) {
      try {
        window.clarity("consent", true);
      } catch {
        // Best-effort accept hook.
      }
    }
  }, [hasConsent]);

  return null;
};

export default AnalyticsConsentBridge;
